import { useMemo, useRef } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { QueueLineModel, ShopperType, ThreeRefs } from '../types';

export const useThreeRefs = (): ThreeRefs => {
  const sceneRef = useRef<THREE.Scene | null>(null);
  const cameraRef = useRef<THREE.PerspectiveCamera | null>(null);
  const rendererRef = useRef<THREE.WebGLRenderer | null>(null);
  const controlsRef = useRef<OrbitControls | null>(null);
  const raycasterRef = useRef<THREE.Raycaster>(new THREE.Raycaster());
  const floorPlaneRef = useRef<THREE.Mesh | null>(null);
  const selectedMeshRef = useRef<THREE.Mesh | null>(null);
  const selectedMeshesRef = useRef<THREE.Mesh[]>([]);
  const isDraggingMeshRef = useRef<boolean>(false);
  const dragPlaneRef = useRef<THREE.Plane>(
    new THREE.Plane(new THREE.Vector3(0, 1, 0), 0)
  );
  const intersectionPointRef = useRef<THREE.Vector3>(new THREE.Vector3());
  const meshOffsetRef = useRef<THREE.Vector3>(new THREE.Vector3());
  const gridHelperRef = useRef<THREE.GridHelper | null>(null);
  const isInQueueLineModeRef = useRef<boolean>(false);
  const currentQueueLineRef = useRef<QueueLineModel | null>(null);
  const queueLinesRef = useRef<QueueLineModel[]>([]);
  const selectedShopperTypeRef = useRef<ShopperType>(
    ShopperType.WomanWithBasket
  );

  const refs = useMemo<ThreeRefs>(
    () => ({
      scene: sceneRef,
      camera: cameraRef,
      renderer: rendererRef,
      controls: controlsRef,
      raycaster: raycasterRef,
      floorPlane: floorPlaneRef,
      selectedMesh: selectedMeshRef,
      selectedMeshes: selectedMeshesRef,
      isDraggingMesh: isDraggingMeshRef,
      dragPlane: dragPlaneRef,
      intersectionPoint: intersectionPointRef,
      meshOffset: meshOffsetRef,
      gridHelper: gridHelperRef,
      isInQueueLineMode: isInQueueLineModeRef,
      currentQueueLine: currentQueueLineRef,
      queueLines: queueLinesRef,
      selectedShopperType: selectedShopperTypeRef,
    }),
    []
  );

  return refs;
};
